import fetcher, { post } from "utils/fetcher";
import type { RefreshResponse } from "types/api/auth/refresh";
import type { UserDetailsResponse } from "types/api/user/details";

/**
 * Set's user as logged in without data
 *
 * @param updateUser - Function to update user in zustand
 */
export const setUserLoggedIn = (
  updateUser: ({ isLoggedIn }: { isLoggedIn: boolean }) => void
): void => {
  updateUser({ isLoggedIn: true });
};

/**
 * Set's user as logged out without data
 *
 * @param updateUser - Function to update user in zustand
 */
export const setUserLoggedOut = (
  updateUser: ({
    isLoggedIn,
    loading,
  }: {
    isLoggedIn: boolean;
    loading: boolean;
  }) => void
) => {
  updateUser({ isLoggedIn: false, loading: false });
};

/**
 * Get information for the user in a valid session
 *
 * @returns Details for the user
 */
export const getUserDetails = async (): Promise<UserDetailsResponse> =>
  fetcher("/system/user/details", {}, true);

/**
 * Refresh the user's session
 *
 * @returns The users refreshed session
 */
export const postAuthRefresh = async (): Promise<RefreshResponse> =>
  post("/system/auth/refresh");
